import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "data-name": "Gruppe 504"
    }, [
      _createElementVNode("path", { d: "M9.498 24a2.894 2.894 0 0 1-2.062-.853L.853 16.56a2.914 2.914 0 0 1 0-4.12L11.975 1.318A4.47 4.47 0 0 1 15.157 0h6.341a2.5 2.5 0 0 1 2.5 2.5v6.343a4.47 4.47 0 0 1-1.318 3.182L11.56 23.147A2.892 2.892 0 0 1 9.498 24Zm5.655-23a3.479 3.479 0 0 0-2.475 1.025L1.56 13.147a1.913 1.913 0 0 0 0 2.7l6.588 6.593a1.961 1.961 0 0 0 2.705 0l11.123-11.123a3.476 3.476 0 0 0 1.022-2.474V2.5a1.5 1.5 0 0 0-1.5-1.5Z" }),
      _createElementVNode("path", { d: "M18.498 8a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5Zm0-4a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Z" })
    ], -1)
  ])))
}
export default { render: render }